import { useContext } from 'react';

import { RtlContext } from '~/context';

export const useIsRtl = () => useContext(RtlContext);
